function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#276EF1;}\n\t.st1{fill:#FFC043;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:20;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 249.8,
  cy: 250.2,
  r: 247.5
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st1",
  cx: 249.8,
  cy: 231.9,
  rx: 194.7,
  ry: 176.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M408.1,367.3c1.3-1.7,2.6-3.4,4-5.1c0.2-0.3,0.3-0.7,0.7-0.9c1.4-1.8,2.6-3.5,3.8-5.5c0.1-0.1,0.1-0.1,0.1-0.2 c1.1-1.8,2.4-3.5,3.5-5.5c0.1-0.2,0.3-0.7,0.6-0.9c1-1.8,2-3.6,3.3-5.5c0.1-0.3,0.3-0.7,0.7-1c1-1.8,2-3.8,3-5.8 c0.1-0.1,0.1-0.3,0.2-0.6c0.9-1.8,1.8-3.8,2.6-5.8c0.1-0.2,0.2-0.6,0.3-0.9c0.9-1.9,1.7-4,2.5-6c0.1-0.3,0.3-0.8,0.3-1.3 c0.8-2,1.6-4.1,2.3-6c0.1-0.2,0.1-0.6,0.2-0.8c0.7-1.9,1.3-4.1,1.8-6c0.1-0.2,0.1-0.3,0.1-0.7c0.7-2,1.1-4.2,1.7-6.3 c0.1-0.3,0.1-0.8,0.2-1.3c0.6-2,0.9-4.2,1.3-6.3c0.1-0.3,0.1-0.7,0.1-1c0.3-2,0.7-4.3,1-6.4c0-0.1,0.1-0.2,0.1-0.3 c0.3-2.3,0.6-4.4,0.8-6.7c0-0.3,0.1-0.8,0.1-1.4c0.1-2,0.3-4.3,0.3-6.6c0-0.3,0-0.8,0.1-1.3c0.1-2.4,0.1-4.6,0.1-6.9v-33.9 c0,2.4-0.1,4.6-0.1,6.9c0,0.3,0,0.8-0.1,1.3c-0.1,2.3-0.2,4.3-0.3,6.6c0,0.3-0.1,0.8-0.1,1.4c-0.1,2.3-0.3,4.4-0.8,6.7 c0,0.1-0.1,0.2-0.1,0.3c-0.2,2-0.7,4.3-1,6.4c-0.1,0.3-0.1,0.7-0.1,1c-0.3,2-0.9,4.3-1.3,6.3c-0.1,0.3-0.1,0.8-0.2,1.3 c-0.6,2-1,4.2-1.7,6.3c-0.1,0.2-0.1,0.3-0.1,0.7c-0.7,2-1.3,4.1-1.8,6c-0.1,0.2-0.1,0.6-0.2,0.8c-0.7,2-1.5,4.1-2.3,6 c-0.1,0.3-0.2,0.8-0.3,1.3c-0.8,1.9-1.6,4.1-2.5,6c-0.1,0.2-0.2,0.6-0.3,0.9c-0.9,1.8-1.7,3.8-2.6,5.8c-0.1,0.1-0.1,0.3-0.2,0.6 c-0.9,1.9-1.9,3.8-3,5.8c-0.1,0.3-0.3,0.7-0.7,1c-1,1.8-2,3.8-3.3,5.5c-0.1,0.2-0.3,0.7-0.6,0.9c-1.1,1.8-2.4,3.6-3.5,5.5 c-0.1,0.1-0.1,0.1-0.1,0.2c-1.3,1.8-2.5,3.6-3.8,5.5c-0.2,0.3-0.3,0.7-0.7,0.9c-1.3,1.7-2.6,3.4-4,5.1c-0.2,0.3-0.6,0.7-0.8,0.9 c-1.5,1.7-2.8,3.5-4.3,5.2c-0.1,0.1-0.1,0.1-0.1,0.1c-1.1,1.4-2.4,2.6-3.5,4c-0.3,0.3-0.7,0.8-1,1.1c-0.9,1-2,2-3,3.3 c-0.2,0.2-0.6,0.7-0.9,0.9c-1.4,1.4-2.6,2.6-4,3.8c-0.2,0.2-0.7,0.7-0.9,0.9c-1,0.9-2,1.9-3.3,2.8c-0.3,0.3-0.8,0.7-1.1,1 c-1.5,1.3-2.7,2.4-4.2,3.5l0,0c-1.5,1.1-2.8,2.4-4.3,3.5c-0.3,0.3-0.8,0.7-1.3,0.9c-1.1,0.9-2.4,1.8-3.5,2.6c-0.3,0.2-0.7,0.6-1,0.8 c-1.6,1-3,2-4.6,3.3c-0.3,0.2-0.7,0.3-1,0.7c-1.3,0.8-2.4,1.6-3.6,2.4c-0.3,0.2-0.9,0.7-1.5,0.9c-1.3,0.8-2.7,1.7-4.1,2.5 c-0.2,0.1-0.3,0.2-0.7,0.3c-1.6,0.9-3.3,1.8-4.9,2.7c-0.3,0.2-0.9,0.3-1.3,0.7c-1.4,0.7-2.5,1.3-3.8,1.9c-0.3,0.2-0.9,0.3-1.5,0.7 c-1.7,0.8-3.4,1.7-5.1,2.5c-0.1,0-0.1,0.1-0.1,0.1c-1.7,0.8-3.3,1.6-5,2.3c-0.6,0.1-0.9,0.3-1.6,0.7c-1.3,0.6-2.6,1-4.1,1.7 c-0.3,0.1-0.9,0.3-1.5,0.6c-1.8,0.7-3.5,1.3-5.4,1.9c-1,0.3-2,0.7-3.2,1c-0.3,0.1-0.8,0.2-1.1,0.3c-1.5,0.3-2.8,0.9-4.3,1.5 c-0.3,0.1-0.7,0.1-0.9,0.2c-1.1,0.3-2.3,0.7-3.4,0.9c-0.6,0.1-1,0.2-1.6,0.3c-0.9,0.2-1.8,0.6-2.8,0.8c-0.7,0.1-1.3,0.2-1.8,0.3 c-0.9,0.1-1.8,0.3-2.6,0.7c-0.7,0.1-1.3,0.2-1.9,0.3c-0.9,0.1-1.7,0.3-2.6,0.6c-0.7,0.1-1.4,0.2-1.9,0.3c-0.9,0.1-1.7,0.3-2.6,0.6 c-0.7,0.1-1.3,0.2-2,0.3c-0.9,0.1-1.7,0.2-2.6,0.3c-0.7,0.1-1.5,0.2-2,0.3c-0.9,0.1-1.7,0.2-2.6,0.3c-0.7,0.1-1.5,0.1-2,0.2 c-0.9,0.1-1.8,0.2-2.6,0.3c-0.7,0.1-1.5,0.1-2,0.2c-0.9,0.1-1.8,0.1-2.6,0.2c-0.7,0.1-1.3,0.1-2,0.1c-0.9,0.1-1.8,0.1-2.7,0.1 c-0.7,0.1-1.3,0.1-2,0.1c-0.9,0.1-1.9,0.1-2.8,0.1c-0.7,0-1.3,0.1-1.8,0.1c-1,0.1-2,0.1-3.3,0.1c-0.6,0-1,0-1.6,0.1 c-1.6,0-3.3,0.1-4.9,0.1c-47,0-90.2-15-123.9-40.3c-7.2-5.4-14-11.3-20.3-17.5c-3.2-3.2-6.1-6.3-9-9.7c-2.8-3.3-5.6-6.8-8.2-10.2 c-0.9-1.1-1.7-2.4-2.6-3.5c-4.2-6-8-12.2-11.5-18.6c-2.7-5.2-5.2-10.5-7.5-15.8c-7.7-19-11.7-39.4-11.7-60.6l0,0v33.9 c0,97.5,87.2,176.5,194.7,176.5c1.6,0,3.3,0,4.9-0.1c0.6,0,1,0,1.6-0.1c1,0,2-0.1,3.3-0.1c0.7,0,1.4-0.1,1.8-0.1 c0.9-0.1,1.9-0.1,2.8-0.1c0.7-0.1,1.3-0.1,2-0.1c0.9-0.1,1.8-0.1,2.7-0.1c0.7-0.1,1.3-0.1,2-0.1c0.9-0.1,1.8-0.1,2.6-0.2 c0.7-0.1,1.5-0.1,2-0.2c0.9-0.1,1.8-0.1,2.6-0.3c0.7-0.1,1.5-0.1,2-0.2c0.9-0.1,1.7-0.2,2.6-0.3c0.7-0.1,1.3-0.1,2-0.3 c0.9-0.1,1.7-0.2,2.6-0.3c0.7-0.1,1.3-0.2,2-0.3c0.9-0.1,1.7-0.3,2.6-0.6c0.7-0.1,1.3-0.2,1.9-0.3c0.9-0.1,1.7-0.3,2.6-0.6 c0.7-0.1,1.4-0.2,1.9-0.3c0.9-0.1,1.8-0.3,2.6-0.7c0.7-0.1,1.3-0.2,1.8-0.3c0.9-0.2,1.8-0.6,2.8-0.8c0.6-0.1,1-0.2,1.6-0.3 c1.1-0.3,2.4-0.7,3.4-0.9c0.3-0.1,0.7-0.1,0.9-0.2c1.5-0.3,2.8-0.9,4.3-1.5c0.3-0.1,0.7-0.2,1-0.3c0.9-0.3,1.9-0.7,2.8-0.9 c0.1,0,0.1-0.1,0.1-0.1c1.8-0.7,3.5-1.4,5.4-1.9c0.3-0.1,0.9-0.3,1.5-0.6c1.4-0.6,2.6-1,4.1-1.6c0.6-0.1,0.9-0.3,1.6-0.7 c1.7-0.7,3.4-1.5,5-2.3c0.1,0,0.1-0.1,0.1-0.1c1.7-0.8,3.4-1.6,5.1-2.5c0.3-0.2,0.9-0.3,1.5-0.7c1.3-0.7,2.6-1.3,3.8-1.9 c0.3-0.2,0.9-0.3,1.3-0.7c1.6-0.9,3.3-1.8,4.9-2.7c0.2-0.1,0.3-0.2,0.7-0.3c1.3-0.8,2.7-1.6,4.1-2.5c0.3-0.2,0.9-0.7,1.5-0.9 c1.3-0.8,2.5-1.6,3.6-2.4c0.2-0.1,0.6-0.3,0.8-0.6c0.1-0.1,0.1-0.1,0.2-0.1c1.6-1,3.2-2,4.6-3.3c0.3-0.2,0.7-0.6,1-0.8 c1.3-0.9,2.4-1.8,3.5-2.6c0.3-0.3,0.8-0.7,1.3-0.9c1.6-1.1,2.8-2.4,4.3-3.5l0,0c1.5-1.1,2.8-2.4,4.2-3.5c0.3-0.3,0.8-0.7,1.1-1 c1-0.9,2-1.9,3.3-2.8c0.3-0.2,0.7-0.7,0.9-0.9c1.3-1.3,2.6-2.5,3.9-3.8c0.2-0.2,0.6-0.6,0.8-0.9c1-1,2-2,3-3.3 c0.3-0.3,0.7-0.8,1-1.1c1.1-1.3,2.4-2.6,3.5-3.9c0.1-0.1,0.1-0.1,0.1-0.1l0,0c1.5-1.7,2.8-3.4,4.3-5.2 C407.8,367.9,408,367.7,408.1,367.3z"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st3",
  cx: 249.8,
  cy: 228.7,
  rx: 162.3,
  ry: 143.2
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 249.8,
  y1: 157.9,
  x2: 249.8,
  y2: 289.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 315.5,
  y1: 223.5,
  x2: 184.2,
  y2: 223.5
}));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "st4",
  cx: 249.8,
  cy: 228.7,
  rx: 154.2,
  ry: 136.1
}));

var SvgMoreTokensButton = function SvgMoreTokensButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.5512,
    y1: -123.0949,
    x2: 444.7987,
    y2: -123.0949,
    gradientTransform: "matrix(1 0 0 -1 0 212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE7C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4355,
    style: {
      stopColor: "#EE9643"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDB144"
    }
  })), _ref5, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.4974,
    y1: -16.66,
    x2: 412.1748,
    y2: -16.66,
    gradientTransform: "matrix(1 0 0 -1 0 212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE7C45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4355,
    style: {
      stopColor: "#EE9643"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDB144"
    }
  })), _ref6), _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoreTokensButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more-tokens-button.fb2a8919.svg";
export { ForwardRef as ReactComponent };